import { v7 as uuidv7 } from 'uuid';
/**
 * Generates random entity identifier.
 */
export function generateEntityId() {
    return uuidv7();
}
//# sourceMappingURL=entity.js.map